import { base58de } from './tron.mjs'

/** Tron 在配置里的 chainId */
export const TRON_CHAIN_ID = 95500

const EVM_ADDR_RE = /^0x[a-fA-F0-9]{40}$/

export function isValidEvmAddress(addr) {
  return EVM_ADDR_RE.test(String(addr || '').trim())
}

export function isValidTronAddress(addr) {
  const a = String(addr || '').trim()
  if (!a || a[0] !== 'T') return false
  try {
    base58de(a)
    return true
  } catch {
    return false
  }
}

/** 按「目标链」校验用户填写的收款地址（原始输入：EVM 为 0x…，Tron 为 T…） */
export function isValidReceiveAddressForToChain(toChainId, addr) {
  const id = Number(toChainId)
  if (id === TRON_CHAIN_ID) return isValidTronAddress(addr)
  return isValidEvmAddress(addr)
}

/** 卡片内展示用缩写（完整地址放在 title 上）；前 10 + … + 后 6，可读性更好 */
export function shortenReceiveAddressDisplay(toChainId, addr) {
  const s = String(addr || '').trim()
  if (!s) return ''
  const id = Number(toChainId)
  const prefixLen = 10
  const suffixLen = 6
  const compactLen = prefixLen + suffixLen
  if (id === TRON_CHAIN_ID && s[0] === 'T') {
    if (s.length <= compactLen) return s
    return `${s.slice(0, prefixLen)}…${s.slice(-suffixLen)}`
  }
  if (EVM_ADDR_RE.test(s)) {
    if (s.length <= compactLen) return s
    return `${s.slice(0, prefixLen)}…${s.slice(-suffixLen)}`
  }
  if (s.length <= compactLen) return s
  return `${s.slice(0, prefixLen)}…${s.slice(-suffixLen)}`
}

const MID_ELLIPSIS = '…'

/**
 * 收款地址中间省略：前 10 + … + 后 6（EVM / Tron 一致），兼顾可读性和空间。
 * 总长 ≤16 则整段用 compact 单行展示（尾 6 字加粗便于扫一眼）。
 */
export function formatReceiveAddressMiddle(_toChainId, addr) {
  const s = String(addr || '').trim()
  if (!s) {
    return {
      compact: true,
      head: '',
      sep: '',
      tail: '',
      tailSoft: '',
      tailBold: '',
      text: '',
    }
  }
  const prefixLen = 10
  const suffixLen = 6
  if (s.length <= prefixLen + suffixLen) {
    const tailBold = s.length > suffixLen ? s.slice(-suffixLen) : s
    const tailSoft = s.length > suffixLen ? s.slice(0, -suffixLen) : ''
    return {
      compact: true,
      head: '',
      sep: '',
      tail: '',
      tailSoft,
      tailBold,
      text: s,
    }
  }
  const head = s.slice(0, prefixLen)
  const tail = s.slice(-suffixLen)
  const tailBold = tail
  const tailSoft = ''
  return {
    compact: false,
    head,
    sep: MID_ELLIPSIS,
    tail,
    tailSoft,
    tailBold,
    text: `${head}${MID_ELLIPSIS}${tail}`,
  }
}
